import React from 'react'

import { feetToFeetAndInches } from 'components/utils/converter'

import { ConfirmDialog } from '../../misc/ConfirmDialog'
import { HistoricalDataEntry } from '../../../api/client'
import moment from 'moment'
import { ProductionCode, TelemetryType } from '../../../api/apiservice'
import { Site } from 'store/Site'

// eslint-disable-next-line react/prop-types
export default function InvalidDatapointDialog(props: {
  currData: HistoricalDataEntry | undefined
  site: Site | undefined
  onClose: (ok: boolean, ...params) => void
}) {
  const onClose = (ok: boolean) => props.onClose(ok, props.currData)
  const action = props.currData?.invalidData ? 'unhide' : 'hide'
  let value = ''
  if (props.currData?.telemetryType === TelemetryType.TankLevel) {
    const isTankChemical = props.site?.tanks.some(
      (tank) =>
        tank.id === props.currData?.assetId &&
        tank.productionCode === ProductionCode.Chemical
    )
    if (!isTankChemical) {
      const [tankLevelFt, tankLevelIn] = feetToFeetAndInches(
        props.currData?.value
      )
      value = `${tankLevelFt.toFixed()}' ${tankLevelIn.toFixed(1)}"`
    } else {
      value = props.currData.value.toFixed(2)
    }
    return (
      <ConfirmDialog title="Confirmation" onAction={onClose}>
        Do you want to {action} this value - <b>({value})</b>?
        <br />
        Date{' '}
        <b>{moment(props.currData?.timestamp).format('MM/DD/YYYY h:mm:ss')}</b>
        <br />
      </ConfirmDialog>
    )
  }

  return (
    <ConfirmDialog title="Confirmation" onAction={onClose}>
      Do you want to {action} this value -{' '}
      <b>({props.currData?.value.toFixed(2)})</b>?
      <br />
      Date{' '}
      <b>{moment(props.currData?.timestamp).format('MM/DD/YYYY h:mm:ss')}</b>
      <br />
    </ConfirmDialog>
  )
}
